import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { DENTAL } from './../../assets/Domains';
import Wellness from './Wellness';
import Dental from './Dental';

const Preferences = (props) => {
  // if (props.currentDomain === DENTAL) {
  //   return <Dental {...props} />;
  // }
  // return <Wellness {...props} />;
  return (
    <div className="prefrence_container">
      <div className={classnames({'prefrence_container__header': !props.preferences?.isFetchingPreferences})}>
      {!props.preferences?.isFetchingPreferences &&<div className="prefrence_container__header_title">Business Preferences</div>}
      {props.currentDomain === DENTAL?
        (<Dental {...props} />):
        (<Wellness {...props} />)
      }
    </div>
    </div>
  )
};

Preferences.defaultProps = {
  currentDomain: '',
  getPreferences: () => {},
  setPreferences: () => {},
};

Preferences.propTypes = {
  currentDomain: PropTypes.string,
};

export default Preferences;
